export const SEARCH_AUTOCOMPLETE_PATH = '/design/moodboards/search_autocomplete';
export const SEARCH_PRODUCTS_PATH = '/design/moodboards/search_products';
export const SEARCH_CUSTOMERS_PATH = '/admin/users/search_customers';
export const TAGS_AUTOCOMPLETE_PATH = '/design/moodboards/tags_autocomplete';
export const FAVOURITE_PRODUCT_PATH = '/products/:product_id/favourite_products.json';
export const FAVOURITE_MOODBOARD_CATEGORIES_PATH = '/design/favourite_moodboard_categories';
export const FAVOURITE_MOODBOARD_TEMPLATES_PATH = '/design/favourite_moodboard_templates';

export const previewMoodboardPath = (projectId, isPublicMoodboard) =>
  `/projects/${projectId}/${isPublicMoodboard ? 'public_' : ''}moodboard/preview`;

export const moodboardPath = moodboardId => {
  let path = '/design/moodboards';
  if (moodboardId) {
    path += `/${moodboardId}`;
  }
  return path;
};

export const copyCategoryPath = moodboardId => `${moodboardPath(moodboardId)}/categories/copy`;

export const categoryPath = categoryId => {
  let path = `${moodboardPath(window.moodboardId)}/categories`;
  if (categoryId) {
    path += `/${categoryId}`;
  }
  return path;
};

export const chatPath = chatId => `/chats/${chatId}`;

export const collectionPath = collectionId => `/admin/collections/${collectionId}`;



// WEBPACK FOOTER //
// ./app/javascript/design/api/routing.js